var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.9998 47.3958C12.6457 47.3958 2.604 37.3542 2.604 25C2.604 12.6458 12.6457 2.60417 24.9998 2.60417C37.354 2.60417 47.3957 12.6458 47.3957 25C47.3957 37.3542 37.354 47.3958 24.9998 47.3958ZM24.9998 5.72917C14.3748 5.72917 5.729 14.375 5.729 25C5.729 35.625 14.3748 44.2708 24.9998 44.2708C35.6248 44.2708 44.2707 35.625 44.2707 25C44.2707 14.375 35.6248 5.72917 24.9998 5.72917Z",
    fill: "#DFDFE6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1042 32.4583C18.7083 32.4583 18.3125 32.3125 18 32C17.3958 31.3958 17.3958 30.3958 18 29.7917L29.7917 18C30.3958 17.3958 31.3958 17.3958 32 18C32.6042 18.6042 32.6042 19.6042 32 20.2083L20.2083 32C19.9167 32.3125 19.5 32.4583 19.1042 32.4583Z",
    fill: "#6260A8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30.8958 32.4583C30.5 32.4583 30.1042 32.3125 29.7917 32L18 20.2083C17.3958 19.6042 17.3958 18.6042 18 18C18.6042 17.3958 19.6042 17.3958 20.2083 18L32 29.7917C32.6042 30.3958 32.6042 31.3958 32 32C31.6875 32.3125 31.2917 32.4583 30.8958 32.4583Z",
    fill: "#6260A8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.0d91b4af82b9abece0dff9904b5f2cd4.svg";
export { ForwardRef as ReactComponent };